export default "__VITE_ASSET__0pyYFu5Q__"